<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
    </nav>

    <div id="page-wrapper">
      <slot />
    </div>

  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>